// Tag.tsx
import React from "react";
import { slugify } from "utils/utils";
import { StyledLink } from "./Tag.styled";
interface TagProps {
  href: string;
  children: string;
}
export const Tag: React.FC<TagProps> = ({
  href,
  children
}) => {
  return <StyledLink title={slugify(children)} href={href} data-sentry-element="StyledLink" data-sentry-component="Tag" data-sentry-source-file="index.tsx">
            #{slugify(children)}
        </StyledLink>;
};